// 価格帯フィルターのレンジスライダー（snippets/price-facet.liquid）
//
// フィルター適用のたびにセクションごと差し替わるため、要素ごとにイベントを張らず
// document への委譲で処理する。初期位置はLiquidが出力する --min-pct / --max-pct と
// value属性で決まるので、描画後の初期化処理は不要。
//
// 金額入力欄に値を反映して input イベントを発火させると、Dawnのフィルターフォームが
// 800msのデバウンス後に絞り込みを実行する（ドラッグ中は走らない）。
(function () {
  function parts(wrap) {
    return {
      min: wrap.querySelector('.flex-price-slider__range--min'),
      max: wrap.querySelector('.flex-price-slider__range--max'),
    };
  }

  function paired(range) {
    const id = range.dataset.pair;
    return id ? document.getElementById(id) : null;
  }

  function paint(wrap) {
    const { min, max } = parts(wrap);
    const limit = Number(max.max) || 0;
    if (!limit) return;

    wrap.style.setProperty('--min-pct', (Number(min.value) / limit) * 100 + '%');
    wrap.style.setProperty('--max-pct', (Number(max.value) / limit) * 100 + '%');
  }

  // つまみが交差しないように丸める
  function clamp(wrap, moved) {
    const { min, max } = parts(wrap);
    if (Number(min.value) > Number(max.value)) {
      if (moved === min) min.value = max.value;
      else max.value = min.value;
    }
  }

  function sync(range, notify) {
    const field = paired(range);
    if (!field) return;

    const next = range.value === range.max && range.classList.contains('flex-price-slider__range--max') ? '' : range.value;
    if (field.value === next) return;

    field.value = next;
    if (notify) field.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('input', (event) => {
    const range = event.target.closest('.flex-price-slider__range');
    if (range) {
      const wrap = range.closest('.flex-price-slider');
      clamp(wrap, range);
      paint(wrap);
      sync(range, true);
      return;
    }

    // 金額を直接入力した場合はつまみを追従させる
    const field = event.target.closest('.facets__price .field__input');
    if (!field || !field.id) return;

    // スライダーは price-range の外にあるため、data-pair から引く
    const wrap = document
      .querySelector('.flex-price-slider__range[data-pair="' + CSS.escape(field.id) + '"]')
      ?.closest('.flex-price-slider');
    if (!wrap) return;

    const { min, max } = parts(wrap);
    const target = [min, max].find((r) => r.dataset.pair === field.id);
    if (!target) return;

    const value = Number(String(field.value).replace(/[^\d.]/g, ''));
    target.value = Number.isFinite(value) && field.value !== '' ? value : target === min ? 0 : target.max;
    paint(wrap);
  });
})();
